import { api } from "../../src/component/constent";

export const getUsers = ({
    search = "",
    page = 1,
    limit = 25,
} = {}) => {

    return api.get(
        "/entry/users",
        {
            params: {
                search,
                page,
                limit,
            },
        }
    );
};

export const getUser = (id) => {

    return api.get(
        `/entry/users/${id}`
    );
};

export const createUser = (data) => {


console.log("data", data);



    return api.post(
        "/entry/users",
        data
    );
};

export const updateUser = (
    id,
    data
) => {

    return api.put(
        `/entry/users/${id}`,
        data
    );
};

export const updateUserStatus = (
    id,
    active
) => {

    return api.patch(
        `/entry/users/${id}/status`,
        {
            active,
        }
    );
};

export const resetUserPassword = (
    id
) => {

    return api.post(
        `/entry/users/${id}/reset-password`
    );
};